import { useDispatch, useSelector } from "react-redux";
import * as mainActions from "_redux/actions/main";
import { useCallback } from "react";
import { ThemeModeEnum } from "_constants";

export const useMainStore = () => {
  const dispatch = useDispatch();

  const _main = useSelector((store) => store.main);

  const setRedirectPath = useCallback(
    (redirectPath = null) =>
      dispatch(mainActions.setRedirectPath(redirectPath)),
    [dispatch]
  );

  const setMobileMenuOpen = useCallback(
    (payload = false) => dispatch(mainActions.setMobileMenuOpen(payload)),
    [dispatch]
  );

  const setThemeMode = useCallback(
    (payload = ThemeModeEnum.DARK) =>
      dispatch(mainActions.setThemeMode(payload)),
    [dispatch]
  );

  const setOnboardingCheckPending = useCallback(
    (payload = false) =>
      dispatch(mainActions.setOnboardingCheckPending(payload)),
    [dispatch]
  );

  return {
    main: _main,
    setRedirectPath,
    setMobileMenuOpen,
    setThemeMode,
    setOnboardingCheckPending,
  };
};
